import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { DatablockColumn } from '../../domain/subscription.types';
import { SubscriptionDatablockItemEntity } from './subscription-datablock-item.entity';

export interface IDatablockListExtra
	extends IListColumnConfig<SubscriptionDatablockItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
}

interface IDatablockListEntity
	extends IListAttrs<SubscriptionDatablockItemEntity> {
	availableColumns: Map<string, IDatablockListExtra>;
}

const entityDefaults: IDatablockListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class SubscriptionDatablockListEntity
	implements
		IDatablockListEntity,
		IListOperations<
			SubscriptionDatablockListEntity,
			SubscriptionDatablockItemEntity
		>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IDatablockListExtra>
	): SubscriptionDatablockListEntity {
		const inst = new SubscriptionDatablockListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IDatablockListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<SubscriptionDatablockItemEntity>
	> {
		return this.availableColumns;
	}
	public setElements(
		elems: Map<string, SubscriptionDatablockItemEntity>
	): SubscriptionDatablockListEntity {
		return produce(this, (draft: SubscriptionDatablockListEntity) => {
			draft.elements = elems;
		});
	}
}
